import { fetchWithAuth } from '../redux/auth/authService';
import { APP_USER_ENDPOINTS } from '../redux/auth/authConstants';

export const appUserService = {
  getList: async () => {
    return fetchWithAuth(APP_USER_ENDPOINTS.GET_LIST, {
      method: 'GET',
    });
  },

  getById: async (userId) => {
    return fetchWithAuth(`${APP_USER_ENDPOINTS.GET_BY_ID}?userId=${userId}`, {
      method: 'GET',
    });
  },

  save: async (userData) => {
    const isFormData = userData instanceof FormData;
    return fetchWithAuth(APP_USER_ENDPOINTS.SAVE, {
      method: 'POST',
      body: isFormData ? userData : JSON.stringify(userData),
    });
  },

  delete: async (userId) => {
    return fetchWithAuth(`${APP_USER_ENDPOINTS.DELETE}?userId=${userId}`, {
      method: 'DELETE',
    });
  },

  getUserFormPermission: async () => {
    return fetchWithAuth(APP_USER_ENDPOINTS.GET_USER_FORM_PERMISSION, {
      method: 'GET',
    });
  },

  getFeedbackFormPermission: async () => {
    return fetchWithAuth(APP_USER_ENDPOINTS.GET_FEEDBACK_FORM_PERMISSION, {
      method: 'GET',
    });
  }
};
